











































































import { Route } from "vue-router";
import Component, { mixins } from "vue-class-component";
import { InputUserUpdate, User } from "@teacherskaya/api-provider/dist/api/UserProvider";
import { checkAuthorities } from "@teacherskaya/tools/dist/lib/SecurityHelpers";
import { getComponentName } from "@/lib/helpers/componentViewController";
import WithUser from "@/mixins/WithUser";
import WithLoggedInUser from "@/mixins/WithLoggedInUser";
import WithLoadingStatus from "@/mixins/WithLoadingStatus";
import WithParamsUserId from "@/mixins/WithParamsUserId";
import config from "@/config";
import GoBack from "@/components/GoBack.vue";
import WrapperCheckRoleAndAuthorities from "@/components/WrapperCheckRoleAndAuthorities.vue";
import ModalConfirm from "@/components/ModalConfirm.vue";
import BasePageTwoColumn from "@/components/BasePageTwoColumn.vue";
import ModalPrompt from "@/components/ModalPrompt";

import ProfileHeader from "./components/ProfileHeader";
import ModalChangePassword from "./components/ModalChangePassword.vue";
import BlockUserNotes from "./components/BlockUserNotes";
import BlockProfileInformation from "./components/BlockProfileInformation";
import BlockRegistrationInformation from "./components/BlockRegistrationInformation";
import BlockPersonalInformation from "./components/BlockPersonalInformation";
import BlockQuestionaryInfo from "./components/BlockQuestionaryInfo";
import BlockSubscriptions from "./components/BlockSubscriptions";
import BlockSubscribers from "./components/BlockSubscribers";
import BlockUserTags from "./components/BlockUserTags";
import BlockTransactions from "./components/BlockTransactions";
import { filterComponents, ProfileComponentData } from "./config";

@Component({
  name: "PageProfile",
  components: {
    BasePageTwoColumn,
    WrapperCheckRoleAndAuthorities,
    ModalPrompt,
    ModalChangePassword,
    ProfileHeader,
    GoBack,
    ModalConfirm,
  },
})
export default class PageProfile extends mixins(
  WithParamsUserId,
  WithUser,
  WithLoggedInUser,
  WithLoadingStatus
) {
  public user: User | null = null;

  public showDeleteDialog: boolean = false;

  public showDisableDialog: boolean = false;

  public showUploadAvatar: boolean = false;

  public components: ProfileComponentData[] = filterComponents([
    { component: BlockProfileInformation },
    { component: BlockPersonalInformation },
    { component: BlockQuestionaryInfo },
    { component: BlockRegistrationInformation },
    ...(config.featureSubscriptions ? [{ component: BlockSubscriptions }, { component: BlockSubscribers }] : []),
    ...[{ component: BlockUserTags }],
    { component: BlockTransactions, right: true, ruleKey: "create", ruleName: "Transactions" },
    { component: BlockUserNotes, right: true },
  ]);

  get userId() {
    return this.paramsUserId;
  }

  get disabled() {
    return this.user ? !!this.user.accountInfo.disabled : false;
  }

  get userRole() {
    return (this.user && this.user.role) || "";
  }

  get userScreenName() {
    return (this.user && this.user.screenName) || "";
  }

  get leftBlock() {
    if (!this.user) return [];
    return this.components.filter(item => {
      return !item.right;
    });
  }

  get rightBlock() {
    if (!this.user) return [];
    return this.components.filter(item => {
      return item.right;
    });
  }

  get hideSelfDelete() {
    return this.userId === this.loggedInUser.id;
  }

  get hideDelete() {
    return !checkAuthorities(this.loggedInUser.authorities || [], ["deleteAnyUser"]);
  }

  public ruleKey(componentItem: any) {
    let prefix = componentItem.ruleKey || "get";
    return this.userId === this.loggedInUser.id ? `${prefix}_my` : `${prefix}_any`;
  }

  public ruleName(componentItem: any) {
    return componentItem.ruleName || getComponentName(componentItem.component);
  }

  public async getData(id = this.userId) {
    this.user = await this.userFindById(id);
  }

  public userUpdateHandler(data: InputUserUpdate) {
    this.userUpdate(data).then((r: User) => (this.user = r));
  }

  public onUpdateUserData() {
    this.getData();
  }

  public async deleteUser() {
    const result = await this.userDelete(this.userId);
    if (result) {
      this.$router.push({ name: "users" });
      this.showDeleteDialog = false;
    }
  }

  public async toggleDisabledUser(disableReason: string) {
    try {
      const disabled = await this.userDisable({
        id: this.userId.toString(),
        disableReason,
        disable: !this.disabled,
      });
      if (this.user?.accountInfo) {
        this.$set(this.user, "accountInfo", { ...this.user.accountInfo, disabled });
      }
    } finally {
      this.showDisableDialog = false;
    }
  }

  public avatarUploadHandler(file: FileList) {
    this.showUploadAvatar = false;
    if (file && file.length > 0) {
      // this.publicFilesUpload({ fileId: { subjectId: this.userId, type: "avatar" }, file }).then(() => {
      //   this.userFindById(this.userId).then(user => {
      //     this.user = user;
      //   });
      // });
    }
  }

  public avatarCancelHandler() {
    this.showUploadAvatar = false;
  }

  public avatarRemoveHandler() {
    if (!this.user || !this.user.avatar) return;
    // this.publicFilesDelete({ fileId: { subjectId: this.userId, type: "avatar" } }).then(() => {
    //   this.userFindById(this.userId).then(user => {
    //     this.user = user;
    //   });
    // });
  }

  public mounted() {
    this.loadingStatusShow([this.getData(this.userId)]);
  }

  public beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    this.loadingStatusShow([this.getData(to.params.userId)]);
    next();
  }
}
